import { Vue, Component } from "vue-property-decorator";
import { Route } from "vue-router";
import AuthModule from "@/store/auth";
import Cognito from "@/plugins/cognito";
import MemberService from "@/services/members";
import ReservationModule from "@/store/reservation";
Component.registerHooks(["beforeRouteEnter"]);

@Component
export default class CheckCommonLogin extends Vue {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  protected async beforeRouteEnter(to: Route, from: Route, next: any) {
    try {
      const authUser = await Cognito.isAuthenticated();
      if (authUser === null) {
        next((vm: this) => {
          if (to.query.animalId) {
            ReservationModule.saveAnimalId(to.query.animalId as string);
          }
          vm.$router.push({ name: "Login", query: { redirect: to.name } });
        });
      } else {
        const userId = authUser.getUsername();
        const meRes = await MemberService.get(userId);
        const user = meRes.data.data[0];
        if (user) {
          next(async () => {
            AuthModule.changeMe(user);
          });
        } else {
          AuthModule.changeMe(null);
          next((vm: this) => {
            if (to.query.animalId) {
              ReservationModule.saveAnimalId(to.query.animalId as string);
            }
            vm.$router.push({ name: "Login", query: { redirect: to.name } });
          });
        }
      }
    } catch (err) {
      AuthModule.changeMe(null);
      next((vm: this) => {
        if (to.query.animalId) {
          ReservationModule.saveAnimalId(to.query.animalId as string);
        }
        vm.$router.push({ name: "Login", query: { redirect: to.name } });
      });
    }
  }
}
